import { ThemeProvider } from '@mui/material';
import Search from './components/navigation-bar/Search';
import AppName from './components/navigation-bar/AppName';
import Cart from './components/navigation-bar/Cart';
import UserAvatar from './components/navigation-bar/UserAvatar';
import appTheme from './AppThemes';

function AppNav(props) {
  return (
    <ThemeProvider theme={appTheme.theme}>
      {props.isLoggedIn !== null && (
        <div>
          <nav className="navbar fixed-top navbar-light bg-light shell-nav">
            <section className="navbar-brand mb-0 h1 nav-img-container">
              <img
                src="/assets/images/CFA_CSymbol_Circle_Red_RGB.png"
                width="37"
                height="37"
                className="d-inline-block align-top"
                alt=""
              />
              <AppName />
            </section>
            <Search />
            <div className="container container-right">
              <UserAvatar />
              <div className="cart-svg">
                <Cart />
              </div>
            </div>
          </nav>
        </div>
      )}
    </ThemeProvider>
  );
}

export default AppNav;
